var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudioCardCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_11826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 2.66699H4.00016C2.5274 2.66699 1.3335 3.8609 1.3335 5.33366V12.0003C1.3335 13.4731 2.5274 14.667 4.00016 14.667H12.0002C13.4729 14.667 14.6668 13.4731 14.6668 12.0003V5.33366C14.6668 3.8609 13.4729 2.66699 12.0002 2.66699Z",
    stroke: "#006AB3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 1.3335V4.00016M10.6668 1.3335V4.00016M1.3335 6.66683H14.6668",
    stroke: "#006AB3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_11826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioCardCalenderIcon);
export default __webpack_public_path__ + "static/media/studio_card_calender_icon.09454e5c46ec7b83c8773d4e02eea81a.svg";
export { ForwardRef as ReactComponent };